import BaseRepository from './base.repository';

class PatientCredentialAuthRepository extends BaseRepository {
  constructor() {
    super('/auth');
  }

  login(payload) {
    // The form handles application outcomes; public proof requests carry no JWT.
    return this.client.post('/login', payload, { silent: true, publicAuth: true });
  }

  changePasswordBeforeLogin(payload) {
    return this.client.post('/complete-password-change', payload, {
      silent: true,
      publicAuth: true,
    });
  }

  changePasswordWhileLoggedIn(payload) {
    return this.client.post('/change-password', payload, { silent: true });
  }
}

export default new PatientCredentialAuthRepository();
